import { useEffect } from 'react';
import { useScreenStore } from '../../stores/useScreenStore';
import { isFullscreen } from '../../utils/fullscreen';

export function useFullscreenListener() {

    useEffect(() => {

        const handleFullscreenChange = () => {

            const currentlyFullscreen = isFullscreen();

            const {
                fullscreenOn,
                setFullscreenOn
            } = useScreenStore.getState();

            if (fullscreenOn !== currentlyFullscreen) {
                setFullscreenOn(
                    currentlyFullscreen
                );
            }

        };

        document.addEventListener(
            'fullscreenchange',
            handleFullscreenChange
        );

        document.addEventListener(
            'webkitfullscreenchange',
            handleFullscreenChange
        );

        document.addEventListener(
            'mozfullscreenchange',
            handleFullscreenChange
        );

        document.addEventListener(
            'MSFullscreenChange',
            handleFullscreenChange
        );

        return () => {

            document.removeEventListener(
                'fullscreenchange',
                handleFullscreenChange
            );

            document.removeEventListener(
                'webkitfullscreenchange',
                handleFullscreenChange
            );

            document.removeEventListener(
                'mozfullscreenchange',
                handleFullscreenChange
            );

            document.removeEventListener(
                'MSFullscreenChange',
                handleFullscreenChange
            );

        };

    }, []);

}